module.exports = __webpack_public_path__ + "static/img/contact.26db68c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact.jpg
// module id = OyUT
// module chunks = 1